/**
 * Quién puede asignar una compu desde el Panel People: los mismos roles que
 * escriben inventario (`peopleTechProcedure`) — el backend lo vuelve a exigir.
 * Hook aparte del componente por la regla react-refresh/only-export-components.
 */
import { useAuth } from '@/contexts/SharedAuthContext';

const ASSIGN_ROLES = ['tech', 'people', 'admin'];

export function useCanAssignEquipment(): boolean {
  const { roles } = useAuth() as { roles?: string[] };
  return (roles ?? []).some((r) => ASSIGN_ROLES.includes(r));
}
